import { Row } from "antd";
import { ColumnsType } from "antd/lib/table";
import {  useEffect, useState } from "react";
import CustomTable from "../../components/_common/Table";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { useLocation, useNavigate } from "react-router-dom";
import { getPadvishRequestLicense } from "../../api/api";
import { UpdatePadvishRequestLicenseList } from "../../redux/reducers/PadvishRequestLicenseSlice";
import { errorNotify } from "../../services/toast.notification";

const LabLicense = () =>{
    const [permission,setPermission] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    const myStore = useAppSelector((state) => state)
    const navigate = useNavigate();
    const {state} = useLocation();
    const { requestId } = state; // Read values passed on state
    const dispatch = useAppDispatch();

    const [expandedRowRender]=useState([
        {title:'نام کامپیوتر',val:'str_ConsoleComputerName'}
        ,{title:'IP کامپیوتر',val:'str_ConsoleComputerIp'}
        ,{title:'کد لایسنس',val:'str_licenseCode'}
        ,{title:'وضعیت',val:'str_Status'}
        ,{title:'تعداد کاربر',val:'int_UserCountlicense'}
        ,{title:'تاریخ انقضا',val:'str_licenseExpireDate'}
        ,{title:'تاریخ نصب',val:'str_InstallDate'}
        
    ]);
    const columns: ColumnsType<any> = [     
        { title: 'نام کامپیوتر', dataIndex: 'str_ConsoleComputerName', key: 'str_ConsoleComputerName', width: 150},
        { title: 'IP کامپیوتر ', dataIndex: 'str_ConsoleComputerIp', key: 'str_ConsoleComputerIp', width: 150 },
        { title: 'کد لایسنس', dataIndex: 'str_licenseCode', key: 'str_licenseCode' , width: 150},
        { title: 'وضعیت ', dataIndex: 'str_Status', key: 'str_Status', width: 150 },
        { title: 'تعداد کاربر', dataIndex: 'int_UserCountlicense', key: 'int_UserCountlicense', width: 150 },
        { title: 'تاریخ انقضا', dataIndex: 'str_licenseExpireDate', key: 'str_licenseExpireDate' , width: 150 },
        {title:'تاریخ نصب',dataIndex:'str_InstallDate', key: 'str_InstallDate' , width: 150 },
];
const loadPadvishRequestLicenses = () => {
    getPadvishRequestLicense(requestId)
       .then((result: any) => {           
           dispatch(UpdatePadvishRequestLicenseList({ padvishRequestLicenseList: result.data.data }))
           setIsLoading(false);
       })
       .catch((error) => {
           setIsLoading(false);
           console.log(error);
           errorNotify(error.response.data.errorMessage, undefined, 5000)
       })
   }

   useEffect(() => {
    loadPadvishRequestLicenses();
}, [])
    return(<>
        <Row>
            <CustomTable 
                columns={columns} 
                expandedRowRender={expandedRowRender}
                data={myStore.padvishRequestLicenseList.list} 
                isloading={isLoading} 
                addButtonTitle={"درخواست جدید"}
                permission={false} />
        </Row>
        </>)
}

export default LabLicense;